/**
 * @function createSizedArray
 * @param {number} size
 * @return {array}
 *
 * Returns an array of a provided size.
 */
export const createSizedArray = size => Array(size).fill(null);

const getTotalPercentage = (base, isNotResident, isSecondHome) => {
    let total = base;

    // non uk residents 2% surcharge
    if(isNotResident) {
        total += 0.02;
    }

    // second home additional 5% surcharge
    if (isSecondHome) {
        total += 0.05;
    }

    return total;
};

export const calculateStampDuty = (property, buyer) => {
    if (!property || !buyer) {
        return 0;
    }
    const { isNotResident, isFirstHome, isSecondHome } = buyer;
    const { priceGbp = 0 } = property;

    let totalDuty = 0;
    let taxableSum = 0;

    //  first home relief
    if (isFirstHome && priceGbp <= 500000) {
        if (isNotResident) {
            if (priceGbp < 300000) {
                totalDuty += (priceGbp - 300000) * getTotalPercentage(0, isNotResident, false);
                taxableSum += (priceGbp - 300000);
            }
            else {
                totalDuty += 300000 * getTotalPercentage(0, isNotResident, false);
                totalDuty += (priceGbp - 300000) * getTotalPercentage(0.05, isNotResident, false);
                taxableSum += priceGbp;
            }

        } else {
            if (priceGbp >= 300001) {
                totalDuty += (priceGbp - 300000) * getTotalPercentage(0.05, isNotResident, false);
                taxableSum += (priceGbp - 300000);

            } else {
                totalDuty += (priceGbp - 300000) * getTotalPercentage(0, isNotResident, false);
            }
        }
    }
    else {
        // first bracket 0 - 125,000
        if (priceGbp) {
            if (priceGbp >= 125001) {
                totalDuty += 125000 * getTotalPercentage(0, isNotResident, isSecondHome);
                if (isNotResident || isSecondHome){
                    taxableSum += 125000;
                }
            } else {
                totalDuty += priceGbp * getTotalPercentage(0, isNotResident, isSecondHome);
                if (isNotResident || isSecondHome) {
                    taxableSum += priceGbp;
                }
            }
        }

        // second bracket 125,001 - 250,000
        if (priceGbp >= 125001){
            if (priceGbp >= 250001) {
                totalDuty += 125000 * getTotalPercentage(0.02, isNotResident, isSecondHome);
                taxableSum += 125000;
            }
            else {
                totalDuty += (priceGbp - 125000) * getTotalPercentage(0.02, isNotResident, isSecondHome);
                taxableSum += (priceGbp - 125000);
            }
        }

        // third bracket 250,001—925,000
        if (priceGbp >= 250001){
            if (priceGbp >= 925001) {
                totalDuty += 675000 * getTotalPercentage(0.05, isNotResident, isSecondHome);
                taxableSum += 675000;
            }
            else {
                totalDuty += (priceGbp - 250000) * getTotalPercentage(0.05, isNotResident, isSecondHome);
                taxableSum += (priceGbp - 250000);
            }
        }

        // fourth bracket 925,001—1.5 million
        if (priceGbp >= 925001){
            if (priceGbp >= 1500001) {
                totalDuty += 575000 * getTotalPercentage(0.1, isNotResident, isSecondHome);
                taxableSum += 575000;
            }
            else {
                totalDuty += (priceGbp - 925000) * getTotalPercentage(0.1, isNotResident, isSecondHome);
                taxableSum += (priceGbp - 925000);
            }
        }

        //  fifth bracket > 1.5million
        if (priceGbp >= 1500001) {
            totalDuty += (priceGbp - 1500000) * getTotalPercentage(0.12, isNotResident, isSecondHome);
            taxableSum += (priceGbp - 1500000);
        }
    }

    return {totalDuty, taxableSum};
};


/**
 * @function findModuleGalleryImages
 * @param {*} data
 * @returns {array}
 * Finds images that are compatible with the gallery modal
 */
export const findModuleGalleryImages = (data) => {
    let images = [];

    if (Array.isArray(data)) {
        data.forEach((d) => {
            images = images.concat(findModuleGalleryImages(d));
        });
    } else if (data && typeof data === 'object' && data.__typename) {
        switch (data.__typename) {
            case 'ImageBlock':
            case 'LargeImageBlock':
                images.push({ image: data.image, caption: data.caption, video: data.video });
                break;
            case 'TwoImagesBlock':
            case 'TwoImagesV2Block':
            case 'TwoImagesLandscapeBlock':
                images.push({ image: data.image1, caption: data.caption1, video: data.video1 });
                images.push({ image: data.image2, caption: data.caption2, video: data.video2 });
                break;
            case 'ThreeImagesBlock':
                images.push({ image: data.image1, caption: data.caption1, video: data.video1 });
                images.push({ image: data.image2, caption: data.caption2, video: data.video2 });
                images.push({ image: data.image3, caption: data.caption3, video: data.video3 });
                break;
            case 'FourImagesBlock':
                images.push({ image: data.image1, caption: data.caption1, video: data.video1 });
                images.push({ image: data.image2, caption: data.caption2, video: data.video2 });
                images.push({ image: data.image3, caption: data.caption3, video: data.video3 });
                images.push({ image: data.image4, caption: data.caption4, video: data.video4 });
                break;
            case 'ImageCarouselBlock':
                data.items.forEach((item) => {
                    images.push({ image: item.image, caption: item.caption, video: item.video });
                });
            default:
                Object.keys(data).forEach((k) => { images = images.concat(findModuleGalleryImages(data[k])); });
                break;
        }
    }

    return images;
};
